import { CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { t } from "../../translations";

const DeleteAccountDialog = ({
  open,
  onClose,
  loading,
  onConfirm,
  selectedLang
}) => {
  return (
    <Dialog open={open} onClose={() => !loading && onClose()}>
      <div style={{ padding: "24px", maxWidth: 400 }}>
        <h2 style={{ margin: "0 0 16px 0", color: "#c62828" }}>
          {t("profile.delete_account_confirm_title", selectedLang)}
        </h2>
        <p style={{ marginBottom: "24px", color: "#666" }}>
          {t("profile.delete_account_confirm_message", selectedLang)}
        </p>
        <div
          style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}
        >
          <button
            style={{
              padding: "8px 16px",
              border: "1px solid #ccc",
              borderRadius: 4,
              background: "#fff",
              cursor: loading ? "not-allowed" : "pointer"
            }}
            onClick={onClose}
            disabled={loading}
          >
            {t("buttons.cancel", selectedLang)}
          </button>
          <button
            style={{
              padding: "8px 16px",
              border: "none",
              borderRadius: 4,
              background: "#c62828",
              color: "#fff",
              cursor: loading ? "not-allowed" : "pointer"
            }}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} style={{ color: "#fff" }} />
            ) : (
              t("profile.delete_account_confirm", selectedLang)
            )}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteAccountDialog;
